export enum ProductType {
  Subscription = 1,
  Package,
}

export interface Product {
  id: number
  type?: ProductType
  price: number
  currency: string
  featured: boolean
  smsCount: number
  identifier: string
}

export interface Subscription extends Product {
  lengthInMonths: number
  monthlyPrice: number
  name: string
}

export interface UserSubscription {
  subscription: {
    daysLeft: number
    nextPaymentDate: string | Date
  } | null
  smsNotificationsUsage: {
    availableAdditionalSmsCount: number | null
    availableSubscriptionSmsCount: number | null
  } | null
}

export interface Package extends Product {}
